import React from 'react'

function Resumé() {
    return (
        // <img src="./photos/clare-henderson-resume.pdf" target="_blank"></img>
        <a href="./photos/cookbook.png" target="_blank">Resumé</a>
    )
}

export default Resumé